import { CoreValue } from "../constants";

export const emptyCoreValue: CoreValue = {
  id: undefined,
  title: "",
  description: "",
  emoji: undefined,
  image: undefined,
};
